import {isDefined} from "../../helpers/typeScriptHelpers";
import {
    MutationResolvers,
    QueryResolvers,
    LocalState as LocalStateType,
    GetLocalStateDocument,
} from "../../generated/graphql";
import {BOOK_ATTENDEE_LOCAL_STATE, GET_LOCAL_STATE} from "../courses/course.graphql";

const DEFAULT_LOCAL_STATE = {
    LocalState: {
        createCourse: {
            locationId: null,
        },
        bookAttendees: {
            selectedAttendee: {
                id: null,
                firstname: null,
                bookedCourseIds: null,
            },
            selectedCourseId: null,
        },
    },
};

const updateLocalLocationId: MutationResolvers["updateLocalLocationId"] = (
    _,
    {id},
    {cache},
) => {
    const data = cache.readQuery({query: GET_LOCAL_STATE}) || DEFAULT_LOCAL_STATE;
    const newData = JSON.parse(JSON.stringify(data));
    newData.LocalState.createCourse.locationId = isDefined(id) ? id : null;
    cache.writeQuery({query: GET_LOCAL_STATE, data: newData});

    return isDefined(id) ? id : null;
};

const bookAttendeeSetSelectedAttendee: MutationResolvers["bookAttendeeSetSelectedAttendee"] = (
    _,
    args,
    {cache},
) => {
    const {id = null, firstname = null, bookedCourseIds = null} = args;
    const data = cache.readQuery({query: BOOK_ATTENDEE_LOCAL_STATE}) || DEFAULT_LOCAL_STATE;
    const newData = JSON.parse(JSON.stringify(data));

    if (id !== null && firstname !== null) {
        newData.LocalState.bookAttendees.selectedAttendee = {
            id,
            firstname,
            bookedCourseIds,
        };
    } else {
        newData.LocalState.bookAttendees.selectedAttendee = null;
    }

    cache.writeQuery({query: BOOK_ATTENDEE_LOCAL_STATE, data: newData});

    return id;
};

const bookAttendeeSetSelectedCourse: MutationResolvers["bookAttendeeSetSelectedCourse"] = (
    _,
    {id = null},
    {cache},
) => {
    const data = cache.readQuery({query: BOOK_ATTENDEE_LOCAL_STATE}) || DEFAULT_LOCAL_STATE;
    const newData = JSON.parse(JSON.stringify(data));

    newData.LocalState.bookAttendees.selectedCourseId = id;

    cache.writeQuery({query: BOOK_ATTENDEE_LOCAL_STATE, data: newData});

    return id;
};

const LocalState: QueryResolvers["LocalState"] = (_, queryArgs, {cache}) => {
    const state: LocalStateType = cache.readQuery({query: GetLocalStateDocument});

    return state || DEFAULT_LOCAL_STATE.LocalState;
};

const resolvers = {
    Query: {
        LocalState,
    },
    Mutation: {
        updateLocalLocationId,
        bookAttendeeSetSelectedAttendee,
        bookAttendeeSetSelectedCourse,
    },
};

export default resolvers;
